<ng-container *transloco="let t">
  @if (page$ | async; as page) {
    <bgo-hero-cover class="mt-xl h-layout block" [title]="page.cover.title" [description]="page.cover.subtitle">
      <cft-breadcrumbs [showBackButton]="false" [breadcrumbs]="page.breadcrumbs"></cft-breadcrumbs>
      <bgo-hero-selling-point> </bgo-hero-selling-point>
      <bgo-hero-call-to-action-section>
        <cft-call-to-action [buttonStyle]="'hero'" callToActionStyle="button" [callToAction]="page.primaryCta" />
        <cft-call-to-action
          [buttonStyle]="'secondary'"
          callToActionStyle="button"
          [showIcon]="false"
          [callToAction]="page.secondaryCta"
        />
      </bgo-hero-call-to-action-section>
    </bgo-hero-cover>
    @if (page.offerings.length) {
      <div class="mt-lg h-content-layout">
        <div class="plot-sm">
          {{ t('industryRegionPage.relatedOfferingsTitle', {regionName: page.region.regionName}) }}
        </div>
        <div class="relative sm:max-h-[5rem]">
          <div class="sm:max-h-[5rem] sm:overflow-y-auto" (scroll)="onScroll($event)" #offeringsContainer>
            <div
              class="touch-scrolling mt-md -mb-2 box-content flex flex-nowrap gap-sm overflow-x-auto pb-2 sm:flex-wrap sm:overflow-x-hidden sm:pr-8"
            >
              @for (offering of page.offerings; track offering.id) {
                <a class="cursor-pointer" [routerLink]="offering.link" [queryParams]="offering.queryParams">
                  <cft-chip colour="grey-lighter">
                    {{ offering.clientFacingLabel || offering.label }}
                  </cft-chip>
                </a>
              }
            </div>
          </div>

          @if (!hasScrolled() && contentOverflow()) {
            <div
              class="pointer-events-none absolute right-0 bottom-0 left-0 hidden h-7 bg-linear-to-t from-white to-transparent sm:block"
            ></div>
          }
        </div>
      </div>
    }
    <div class="mt-2xl space-y-3xl md:space-y-20">
      @for (section of page.content; track $index; let last = $last) {
        @if (section.__type === 'ProDirectory') {
          <bgo-pro-directory-by-region-section
            [class.pb-4xl]="last"
            [region]="page.region"
            [industryId]="page.industry.id"
            [id]="$index | regionalDirectoryCssId"
          />
        } @else if (section.__type === 'PresentationSection') {
          <bgo-presentation-section [section]="section" [class.pb-4xl]="last"></bgo-presentation-section>
        } @else if (section.__type === 'ReviewSection') {
          <bgo-reviews-section
            [reviewSection]="section"
            (buttonClicked)="navigateToAboutUsPage()"
            class="h-content-layout"
            [class.pb-4xl]="last"
          ></bgo-reviews-section>
        } @else if (section.__type === 'SupportSection') {
          <bgo-support-section [supportSection]="section"></bgo-support-section>
        } @else if (section.__type === 'ContentSection' && section.content.json) {
          <cft-content-section
            [title]="section.title"
            [plot]="section.plot"
            titleAlignment="left"
            class="h-content-layout"
            [class.pb-4xl]="last"
          >
            <bgo-rich-text [content]="section.content"></bgo-rich-text>
          </cft-content-section>
        } @else if (section.__type === 'SignupSection') {
          <bgo-lead-signup-section [section]="section"></bgo-lead-signup-section>
        } @else if (section.__type === 'ProMapSection') {
          <bgo-pro-map
            [region]="page.region"
            [title]="section.title"
            [industryIds]="[page.industry.id]"
            [sectionId]="section.id"
          />
        } @else if (section.__type === 'RelatedRegionSection') {
          @if (page.region.relatedRegions.length) {
            <bgo-related-items-section
              [title]="section.title | bgoReplaceProps: {regionName: page.region.regionName}"
              [relatedItems]="page.region.relatedRegions | mapRelatedRegionsAndIndustry: page.industry.slug"
            />
          }
        } @else if (section.__type === 'RelatedIndustrySection' && section.industries.length) {
          <bgo-related-items-section
            [title]="section.title | bgoReplaceProps: {regionName: page.region.regionName}"
            [relatedItems]="section.industries | mapRelatedIndustries: page.region.slug"
          />
        } @else if (isRelatedArticlesSection(section) && !!section.relatedTopics.length) {
          <bgo-related-articles-section [section]="section"></bgo-related-articles-section>
        } @else if (section.__type === 'VideoSection') {
          <bgo-video-section class="h-content-layout" [section]="section" />
        }
      }
    </div>
    <bgo-sticky-bottom-navigation [class.sticky-navigation-show]="showStickyFooter" />
  }
</ng-container>
